<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_alarms"
        :mod-count="modCount"
        :url="url"
        :columns="columns"
        :search-form-fields="formFields"
        :show-column-visible="true"
        :offset-height="offsetHeight"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'Dashboard',
  components: { TableWrapper },
  data() {
    return {
      url: this.$config.apiContextPath + '/alarm',
      modCount: 0,
      garages: this.loadGarages()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '告警日期', width: '200px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择告警日期...', type: 'dateranger', hidden: true },
          { label: '告警车库', placeholder: '请选择告警车库...', name: 'parkingId', width: '200px', type: 'select', options: this.garages },
          { label: '告警车辆', placeholder: '请输入车辆编码...', name: 'planetNumber', width: '140px', type: 'input' },
          { label: '车辆用户', placeholder: '请输入车辆用户...', name: 'user', width: '140px', type: 'input' },
          { label: '告警类型', placeholder: '请选择告警类型', name: 'type', width: '140px', type: 'select', hidden: false, options: [
            { label: '进', value: 0 },
            { label: '出', value: 1 }]
          },
          { label: '告警状态', placeholder: '请选择告警状态', name: 'alarmStatus', width: '140px', type: 'select', hidden: false, options: [
            { label: '未处理', value: 0 },
            { label: '已确认', value: 1 },
            { label: '已取消', value: 2 }]
          }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '车库', align: 'left', key: 'parking', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.parking || '---')
          }
        },
        { title: '车辆编号', align: 'center', key: 'planetNumber', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.planetNumber || '---')
          }
        },
        { title: '识别编号', align: 'center', key: 'abnormalVehicle', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.abnormalVehicle || '---')
          }
        },
        { title: '车辆用户', align: 'left', key: 'member', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.member || '---')
          }
        },
        { title: '告警类型', align: 'center', key: 'type', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.type === 0 ? '进' : '出') // (params.row.type === 2 ? '出库' : '异常'))
          }
        },
        { title: '告警状态', align: 'center', key: 'alarmStatus', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.alarmStatus === 0 ? 'red' : (params.row.alarmStatus === 1 ? 'green' : '#9c9c9c') }
            }, params.row.alarmStatus === 0 ? '未处理' : (params.row.alarmStatus === 1 ? '已确认' : '已取消')) // (params.row.type === 2 ? '出库' : '异常'))
          }
        },
        { title: '告警时间', align: 'center', key: 'faultTime', sortable: true, width: 160, ellipsis: true, tooltip: true },
        { title: '操作时间', align: 'center', key: 'updateTime', sortable: true, width: 160, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.updateTime || '---')
          }
        },
        { title: '操作', align: 'center', width: 160, key: '_actions', disabled: true,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: {
                  color: params.row.alarmStatus === 0 ? '#126D91' : '#9c9c9c',
                  cursor: params.row.alarmStatus === 0 ? 'pointer' : 'not-allowed',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    if (params.row.id && params.row.alarmStatus === 0) {
                      this.showChangeAlarmStatusModalDialog(params.row.id, params.row.planetNumber)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-check': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: params.row.alarmStatus === 0 ? '确认告警信息' : '告警信息已确认或者被取消'
                  }
                }, '确认')
              ]),
              h('a', {
                style: {
                  color: params.row.alarmStatus === 0 ? '#126D91' : '#9c9c9c',
                  cursor: params.row.alarmStatus === 0 ? 'pointer' : 'not-allowed',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    if (params.row.id && params.row.alarmStatus === 0) {
                      this.showChangeAlarmStatusModalDialog(params.row.id, params.row.planetNumber, true)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-times': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: params.row.alarmStatus === 0 ? '取消告警信息' : '告警信息已取消或者被确认'
                  }
                }, '取消')
              ])
            ])
          }
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    showChangeAlarmStatusModalDialog: function(id, planetNumber, cancel) {
      const _this = this
      this.$Modal.confirm({
        title: (cancel ? '取消' : '确认') + '车辆告警信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, planetNumber)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/alarm/' + id + '/action/' + (cancel ? 'cancel' : 'acknowledge'),
            method: 'PUT'
          }).then(res => {
            this.$Notice.success({
              title: '状态更新成功',
              desc: '车辆告警 `' + planetNumber + '` 状态更新成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '状态更新失败',
              desc: '车辆告警 `' + name + '` 状态更新失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    }
  }
}
</script>
